import Vue from 'vue'
import VueRouter from 'vue-router'
import Menu from '../boot/Menu.vue'
import Home from '../boot/home/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'menu'
  },
  {
    path: '/menu',
    component: Menu,
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: Home
      },
      {
        path: '/help',
        component: () => import(/* webpackChunkName: "help" */ '../boot/home/Help.vue')
      },
      {
        path: '/news/:id',
        component: () => import(/* webpackChunkName: "news" */ '../boot/news/News.vue'),
        children: []
      },
      {
        path: '/publish/:id',
        component: () => import(/* webpackChunkName: "publish" */ '../boot/news/Publish.vue'),
        children: []
      },
      {
        path: '/about/:id',
        component: () => import(/* webpackChunkName: "about" */ '../boot/home/About.vue'),
        children: []
      },
      {
        path: '/product/:id',
        component: () => import(/* webpackChunkName: "product" */ '../boot/product/Product.vue'),
        children: []
      },
      {
        path: '/purchase/:id',
        component: () => import(/* webpackChunkName: "purchase" */ '../boot/product/Purchase.vue'),
        children: []
      },
      {
        path: '/lesson/:id',
        component: () => import(/* webpackChunkName: "lesson" */ '../boot/lesson/Lesson.vue'),
        children: []
      },
      {
        path: '/classes/:id',
        component: () => import(/* webpackChunkName: "classes" */ '../boot/lesson/Classes.vue'),
        children: []
      },
      {
        path: '/cert/eval',
        component: () => import(/* webpackChunkName: "eval" */ '../boot/cert/CertEval.vue'),
        children: []
      },
      {
        path: '/cert/train',
        component: () => import(/* webpackChunkName: "train" */ '../boot/cert/CertTrain.vue'),
        children: []
      },
      {
        path: '/resource/:id',
        component: () => import(/* webpackChunkName: "resource" */ '../boot/lesson/Resource.vue'),
        children: []
      },
      {
        path: '/account/:id',
        component: () => import(/* webpackChunkName: "account" */ '../boot/user/Account.vue'),
        children: []
      },
      {
        path: '/userinfo',
        component: () => import(/* webpackChunkName: "userinfo" */ '../boot/user/UserInfo.vue'),
        children: []
      },
      {
        path: '/mylesson',
        component: () => import(/* webpackChunkName: "mylesson" */ '../boot/lesson/MyLesson.vue'),
        children: []
      },
      {
        path: '/myproductbuy',
        component: () => import(/* webpackChunkName: "myproductbuy" */ '../boot/product/MyProductBuy.vue'),
        children: []
      },
      {
        path: '/myproduct',
        component: () => import(/* webpackChunkName: "myproduct" */ '../boot/product/MyProduct.vue'),
        children: []
      }
    ]
  },
  {
    path: '/work/:id',
    component: () => import(/* webpackChunkName: "work" */ '../boot/work/Work.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  // base: 'tsdbcloud/cloud-config-server/web', // 基路径,这个地方不加  '/'
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 如果有 savedPosition（例如浏览器后退或前进），则恢复这个位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 每次路由跳转都回到页面顶部
      return { x: 0, y: 0 }
    }
  }
})

// 挂在路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 是一个函数，表示放行到哪一个页面
  next()
})

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
